import { render, staticRenderFns } from "./PayslipViewModal.vue?vue&type=template&id=37ea260f&"
import script from "./PayslipViewModal.vue?vue&type=script&lang=js&"
export * from "./PayslipViewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports